module.exports = __webpack_public_path__ + "img/arrow-right-gray.cc7e297b.svg";